import { Box, Typography } from '@mui/material'
import TableCustom from 'component/Table/TableCustom'
import TableRowCommon from 'component/Table/TableRowCommon'
import { colors } from 'constants/theme'
import PageModal from 'new-components/modal/page-modal'
import { useTranslation } from 'react-i18next'
import { numberFormat } from 'utils/app.utils'
import { dateToView } from 'utils/date.utils'


type PopInstallmentDetailProps = {
    open: boolean
    onClose: () => void
    data: any
}

const PopInstallmentDetail = (props: PopInstallmentDetailProps) => {
    const { t } = useTranslation()

    const { open, onClose, data } = props

    const headCells = [
        { id: 'no', disablePadding: false, label: t('INSTALLMENT.POPUP_DETAIL.TABLE.TIMES'), width: '50px', align: 'center', class: 'text-nowrap ' },
        { id: 'operativeName', disablePadding: false, label: t('INSTALLMENT.POPUP_DETAIL.TABLE.DATE_PAID'), align: 'left', width: '180px', class: 'text-nowrap ' },
        { id: 'installmentPaidDate', disablePadding: false, label: t('INSTALLMENT.POPUP_DETAIL.TABLE.DATE_PAY'), align: 'left', width: '180px', class: 'text-nowrap ' },
        { id: 'totalPrice', disablePadding: false, label: t('VN'), align: 'left', width: '180px', class: 'text-nowrap ' },
        { id: 'totalPaid', disablePadding: false, label: t('INSTALLMENT.POPUP_DETAIL.TABLE.NO_RECIPTNUMBER'), align: 'left', class: 'text-nowrap ' },
        { id: 'installmentTotal', disablePadding: false, label: t('INSTALLMENT.POPUP_DETAIL.TABLE.TOTAL_PRICE'), align: 'right', width: '180px', class: 'text-nowrap p-3' },
    ]

    const renderDataInstallmentDetail = (objData: any, index: number, sum: boolean) => {

        if (sum) {
            const newTotal = data?.installmentList?.reduce((total: number, item: any) => {
                if (item?.status === 'PAID') {
                    return total += item?.price
                } else {
                    return total
                }
            }, 0)

            const objRenderData = {
                key: 'installment-final',
                id: 'installment-final',
                obj: objData,
                columns: [
                    { option: 'MERGE', colSpan: 4, align: 'center', class: 'text-nowrap ' },
                    { option: 'TEXT', align: 'center', label: t('INSTALLMENT.POPUP_DETAIL.TABLE.SUM_TOTAL'), class: 'text-nowrap ' },
                    { option: 'TEXT', align: 'right', label: numberFormat(newTotal) || '0', class: 'text-nowrap ' },
                ]
            }
            return (<TableRowCommon {...objRenderData} />)
        }

        const { installmentPaymentId, installmentPaidDate, paidDate, status, installmentNumber, vnNumber, receiptNumber, price } = objData

        index = index + 1

        const newPaid = status === 'PAID' ? price : 0

        const objRenderData = {
            key: installmentPaymentId,
            id: installmentPaymentId,
            obj: objData,
            columns: [
                { option: 'TEXT', align: 'center', label: installmentNumber, class: 'text-nowrap ' },
                { option: 'TEXT', align: 'left', label: paidDate ? dateToView(paidDate) : '-', class: 'text-nowrap ' },
                { option: 'TEXT', align: 'left', label: (installmentPaidDate && installmentPaidDate !== "null") ? dateToView(installmentPaidDate) : '-', class: 'text-nowrap ' },
                { option: 'TEXT', align: 'left', label: (vnNumber && vnNumber !== "null") ? vnNumber : '-', class: 'text-nowrap ' },
                { option: 'TEXT', align: 'left', label: (receiptNumber && receiptNumber !== "null") ? receiptNumber : '-', class: 'text-nowrap ' },
                { option: 'TEXT', align: 'right', label: numberFormat(newPaid) || '0', class: 'text-nowrap ' },
            ]
        }
        return (<TableRowCommon {...objRenderData} />)
    }

    return (
        <>
            <PageModal
                title={t('INSTALLMENT.POPUP_DETAIL.TITLE')}
                size={'M'}
                isOpen={open}
                handleClose={onClose}
                onCancel={{ onClick: onClose }}
                onSubmit={{ onClick: () => null }}
                onCloseSubmit
                overflow
            >
                <Box>
                    <Box display={'flex'} alignItems={'center'} gap={'16px'} marginTop={'16px'}>
                        <Typography fontWeight={500}>{t('INSTALLMENT.POPUP_CHANGE.OP_CODE')}:{` ${data?.operativeCode || '-'}`}</Typography>
                        <Typography fontWeight={500}>{t('INSTALLMENT.POPUP_CHANGE.OP_NAME')}:{` ${data?.operativeName || '-'}`}</Typography>
                    </Box>
                    <Box marginTop={'16px'}>
                        <TableCustom
                            page={1}
                            pageLimit={100}
                            sortType={''}
                            sortBy={''}
                            onSort={() => null}
                            setPageLimit={() => null}
                            setPage={() => null}
                            rowCount={data?.installmentList?.length}
                            headCells={headCells}
                            rowsData={data?.installmentList?.length ? [...data?.installmentList.map((item: any, index: number) => renderDataInstallmentDetail(item, index, false)), renderDataInstallmentDetail({}, 0, true)] : []}
                            hidePagination
                        />
                    </Box>
                    {data?.status === "CANCEL" &&
                        <Box marginTop={'16px'}>
                            <Typography>
                                <span style={{ color: colors.statusInactive }}>{t('INSTALLMENT.POPUP_DETAIL.REMARK_CANCEL')}:</span>
                                {` ${data?.cancelRemark}` || '-'}
                            </Typography>
                            <Typography>
                                <span style={{ color: colors.statusInactive }}>{t('INSTALLMENT.POPUP_DETAIL.CANCEL_BY')}:</span>
                                {` ${data?.cancelBy}` || '-'}
                            </Typography>
                        </Box>
                    }
                </Box>
            </PageModal>
        </>
    )
}

export default PopInstallmentDetail